import router from "../router";
import store from "../store";
import cookie from "@utils/store/cookie";
import { isWeixin } from "@utils";
import { oAuth } from "@libs/wechat";

export default function toLogin(push, backUrl) {
  store.commit("LOGOUT");
  // const { fullPath, name } = router.currentRoute;
  // 拼团详情页登录 返回页面路劲地址需要参数项的配置
  const fullPath = window.location.pathname + window.location.search;
  cookie.set("login_back_url", backUrl || fullPath);
  oAuth();
  // if (isWeixin()) {
  //   oAuth();
  // } else {
  //   if (name !== "Login") {
  //     push
  //       ? router.push({ path: "/login" })
  //       : router.replace({ path: "/login" });
  //   }
  // }
}
